const getZipcodeValidationStatus = async (zipcode) => {
  try {
    const response = await fetch(
      `/api/zipcodeChecker?zipcode=${encodeURIComponent(zipcode)}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      // The route reports why it failed via `reason`; without it this logged
      // "[object Response]", which said nothing about the actual cause.
      const body = await response.json().catch(() => null);

      console.error(
        `[zipcodeChecker] lookup failed (${response.status})`,
        body?.reason ?? 'no reason returned',
        body?.googleStatus ?? ''
      );

      return {
        success: false,
        reason: body?.reason,
        message: 'Failed to fetch data from Google Maps',
        status: response.status
      };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching Google Maps data:', error);
    return {
      success: false,
      message: error.message,
      data: error.data
    };
  }
};

export { getZipcodeValidationStatus };
